import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#c6a300",
            light: "#ffd21f",
            dark: "#937800",
            contrastText: "#6085e0",
        },
        secondary: {
            main: "#4763a8",
        },
        background: {
            default: "#fffff7",
        },
    },
});